<script>
import { required } from "vuelidate/lib/validators";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import DatePicker from "vue2-datepicker";
export default {
    name: "StockItemModal",
    components: {
        MaskedInput,
        DatePicker,
    },
    data() {
        return {
            modalTitle: "Update Stock Item",
            form: {
                id: 0,
                inventoryDate: "",
                balancePerCard: "",
                onHandPerCount: "",
            },
            submitted: false,
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: true,
            }),
        };
    },
    validations: {
        form: {
            inventoryDate: { required },
            balancePerCard: { required },
            onHandPerCount: { required },
        },
    },
    methods: {
        onCreate() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) return;
            let data = JSON.parse(JSON.stringify(this.form));
            data.inventoryDate = this.getDate(this.form.inventoryDate);
            data.balancePerCard = this.getExactAmt(this.form.balancePerCard);
            data.onHandPerCount = this.getExactAmt(this.form.onHandPerCount);
            this.$emit("submit", data);
        },
        updateData(data) {
            this.form = JSON.parse(JSON.stringify(data));
            this.form.inventoryDate = new Date(data.inventoryDate);
            this.form.balancePerCard = data.balancePerCard ? data.balancePerCard.toString() : "";
            this.form.onHandPerCount = data.onHandPerCount ? data.onHandPerCount.toString() : "";
        },
    },
}
</script>
<template>
    <b-modal
        id="stock-item-modal"
        :title="modalTitle"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <form
            @submit.prevent="onCreate"
            class="needs-validation"
            ref="fcForm"
        >
            <div class="mb-3">
                <label for="inventoryDate">Inventory Date</label>
                <date-picker
                    id="inventoryDate"
                    v-model="form.inventoryDate"
                    :first-day-of-week="1"
                    lang="en"
                    placeholder="Enter Inventory Date..."
                    :class="{ 'is-invalid': $v.form.inventoryDate.$error }"
                >
                </date-picker>
                <div
                    v-if="submitted && $v.form.inventoryDate.$error"
                    class="invalid-feedback"
                >
                    <span v-if="!$v.form.inventoryDate.required"
                        >This value is required.</span
                    >
                </div>
            </div>
            <div class="mb-3">
                <label for="balancePerCard">Balance Per Card</label>
                <masked-input
                    autocomplete="off"
                    type="text"
                    v-model="form.balancePerCard"
                    placeholder="Enter Balance Per Card..."
                    class="form-control"
                    :class="{
                        'is-invalid': submitted && $v.form.balancePerCard.$error,
                    }"
                    :mask="currencyMask"
                ></masked-input>
                <div v-if="submitted && $v.form.balancePerCard.$error" class="invalid-feedback">
                    <span v-if="!$v.form.balancePerCard.required">This value is required.</span>
                </div>
            </div>
            <div class="mb-3">
                <label for="onHandPerCount">On Hand Count</label>
                <masked-input
                    autocomplete="off"
                    type="text"
                    v-model="form.onHandPerCount"
                    placeholder="Enter On Hand Count..."
                    class="form-control"
                    :class="{
                        'is-invalid': submitted && $v.form.onHandPerCount.$error,
                    }"
                    :mask="currencyMask"
                ></masked-input>
                <div v-if="submitted && $v.form.onHandPerCount.$error" class="invalid-feedback">
                    <span v-if="!$v.form.onHandPerCount.required">This value is required.</span>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary"><i class="bx bx-save"></i>{{ form.id != 0 ? "Update" : "Save" }}</button>
                <button type="button" class="btn btn-link" @click="$bvModal.hide('stock-item-modal')">Close</button>
            </div>
        </form>
    </b-modal>
</template>